import React from 'react'
import classNames from 'classnames'

import { STEPS } from '../helpers/steps'

const stepName = step => {
  switch (Number(step)) {
    case STEPS.DATETICKETS:
      return 'date'
    case STEPS.EVENTS:
      return 'events'
    case STEPS.PARTY:
      return 'party'
    case STEPS.ADDONS:
      return 'upgrades'
  }
}
const stepHeadingClassName = (currentStep, targetStep, disable) => {
  const classes = classNames('cta-label', {
    'text-depths': currentStep >= targetStep || !disable,
    'text-dark-gray': currentStep < targetStep || disable
  })

  return classes
}

const renderStepDot = (currentStep, targetStep, disable) => {
  const past = currentStep > targetStep && !disable
  const active = currentStep === targetStep && !disable

  return (
    <span
      className={classNames(
        'block rounded-full absolute left-0 top-0 z-1 border-dark-gray',
        {
          'bg-white': (!active && !past) || disable,
          'bg-depths': past,
          'bg-green': active
        }
      )}
      style={{
        borderWidth: 1,
        height: 8,
        marginLeft: -3,
        marginTop: 8,
        width: 8
      }}
    />
  )
}

function CartSummaryStepHeader({
  currentStep,
  targetStep,
  setStep,
  title,
  last = false,
  noEdit,
  disable
}) {
  const onClickEdit = () => {
    setStep(targetStep)
  }

  return (
    <React.Fragment>
      {renderStepDot(currentStep, targetStep, disable)}
      {!last && (
        <span
          className="bg-dark-gray block absolute inset-y-0 left-0"
          style={{
            marginBottom: -8,
            marginTop: 8,
            width: 1
          }}
        />
      )}

      <div className="flex justify-between items-center h-24">
        <h3 className={stepHeadingClassName(currentStep, targetStep, disable)}>
          {title}
        </h3>

        {currentStep > targetStep && !noEdit && (
          <button
            onClick={onClickEdit}
            type="button"
            className="text-link"
            data-testid={`edit-${stepName(targetStep)}`}
          >
            Edit
            <span className="sr-only">{title} for Your Reservation</span>
          </button>
        )}
      </div>
    </React.Fragment>
  )
}

export default CartSummaryStepHeader
